module.exports = __webpack_public_path__ + "static/media/ShopOn.e2541ef7.gif";